import { render } from "./DeletedPharmacies.vue?vue&type=template&id=e426f5a8&scoped=true"
import script from "./DeletedPharmacies.vue?vue&type=script&lang=js"
export * from "./DeletedPharmacies.vue?vue&type=script&lang=js"

import "./DeletedPharmacies.vue?vue&type=style&index=0&id=e426f5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e426f5a8"]])

export default __exports__